<template>
  <section class="content">
    <div class="row center-block">
      <div class="col-md-12">
        <div class="box m-h-700">
          <!--<div class="box-header">-->
            <!--<h3 class="box-title">停賣列表</h3>-->
          <!--</div>-->
          <!-- /.box-header -->
          <div class="box-body form-inline">
            <div class="form-group" v-if="brandBrief.length > 1 && $route.name !== 'storeInfo'">
              <!-- <select class="form-control h-38" v-model="brandSelect">
                <option v-for="brand in brandBrief" :value="brand.value">
                  {{brand.label}}
                </option>
              </select> -->
              <multiselect
                v-model="brandSelect"
                :options="brandBrief"
                :searchable="true"
                :allow-empty="false"
                :close-on-select="true"
                placeholder="== 品牌 =="
                :show-labels="false"
                :multiple="false"
                label="label"
                track-by="value"
                @input="getAmountLimitSetting('useBrand')"
              >
              </multiselect>
            </div>
            <div class="form-group" v-if="brandSelect.value !== 999999 && brandSelect.value !== '999999' && storeBrief.length > 0">
              <multiselect
                v-model="storeSelect"
                :options="storeBrief"
                :searchable="true"
                :allow-empty="false"
                :close-on-select="true"
                placeholder="== 門市 =="
                :show-labels="false"
                :multiple="false"
                label="label"
                track-by="value"
                @input="getAmountLimitSetting('useStore')"
              >
              </multiselect>
            </div>
            <div class="form-group text-left">

                <div class="btn btn-default"  @click="enable_limit">啟用門市限時限量</div>
              
              <!-- <router-link v-else-if="getRoleType === 99" :to="{path: '/crLimitScheduleItem' + '?brand_id=' + brandSelect.value}">
                <div class="btn btn-default">啟用限時限量</div>
              </router-link>
              <router-link v-else :to="{path: '/crLimitScheduleItem'}">
                <div class="btn btn-default">啟用限時限量</div>
              </router-link> -->
            </div>

            <button v-if="!del_fun" class="btn btn-default pull-right"  @click="del_item()" >
              刪除
            </button>
            <button v-if="del_fun" class="btn btn-danger m-y-10 pull-right" data-toggle="modal" data-target="#limiModal" >
              刪除
            </button>
            <button v-if="del_fun" @click="del_fun = false" class="btn btn-default m-y-10 inline-block pull-right  m-r-10" data-toggle="modal">
              取消
            </button>
            <!-- <div class="form-group text-left">
              <router-link :to="{path: '/crDisableScheduleItem'}">
                <div class="btn btn-default btn-table-title">新增單一商品時段停賣</div>
              </router-link>
            </div> -->
            <!--<dis-item-table :storeId="storeSelect"/>-->
            <div class="row">
              <div class="col-sm-12 table-responsive p-x-0">
                <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
                  <thead>
                  <tr role="row">
                    <th v-if="del_fun" width="2%" colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class=""><input type="checkbox" v-model="selectAllItem" @change="selectAll" /></th>
                    <th colspan="1" width="3%" rowspan="1" aria-controls="example1" tabindex="0" class="">序號</th>
                    <th colspan="1" width="15%"  rowspan="1" aria-controls="example1" tabindex="0" class="">門市限時限量名稱</th>
                    <th colspan="1" width="30%" rowspan="1" aria-controls="example1" tabindex="0" class="">描述</th>
                    <th colspan="1" width="15%" rowspan="1" aria-controls="example1" tabindex="0" class="">門市名稱(ID)</th>
                    <th width="20%"> </th>
                  </tr>
                  </thead>
                  <tbody v-if="isLoading">
                    <tr>
                      <td colspan="12" class="text-center">資料讀取中......</td>
                    </tr>
                  </tbody>
                  <tbody v-else-if="settingList.length === 0">
                    <tr style="background-color: white">
                      <td rowspan="1" colspan="12" style="text-align: center; padding-bottom: 80px; padding-top:80px;">
                        <img src="/static/img/noMatchdata.svg" style="max-width: 148px;" class="center-block logo">
                        <span style="margin-bottom: 80px; color: #696969;">沒有符合的資料</span>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else-if="settingList.length > 0">
                    <tr  class="even" role="row" v-for="(setting, index) in settingList">
                      <td v-if="del_fun" ><input type="checkbox" v-model="setting.selectItem" /></td>
                      <td class="sorting_1">{{index + 1}}</td>
                      <td>{{setting.name}} </td>
                      <td>{{setting.description}}</td>
                      <td>{{setting.store_name}}({{setting.store_id}})</td>
                      <td>
                        <router-link :to="'/upLimitScheduleItem/' + setting.setting_id + '?brand_id=' + setting.brand_id + '&store_id=' + setting.store_id">
                          <button class="btn btn-default"><i class="fa fa-pencil"></i></button>
                        </router-link>
                        <router-link :to="'/copyLimiScheduleItem/' + setting.setting_id  + '?brand_id=' + setting.brand_id + '&store_id=' + setting.store_id">
                          <button class="btn btn-default">複製門市限時限量設定</button>
                        </router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <paginate :pageAmount="pageAmount" :total="total" :isActive="isActive"
                        :groupAmount="groupAmount" :clickPage="clickPage" ref="orderPaginate"
              >
              </paginate>
            </div>
            <!-- /.box-body -->
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" role="dialog" id="storesModal">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">"{{current.name}}"使用門市</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12 p-x-0">
                <div class="inline-block" style="margin: 2.5px 5px 2.5px 0px;" v-for="store in current.store_list">
                  <label class="label label-primary">{{store.name}}</label>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-default" data-dismiss="modal">確定</button>
          </div>
        </div>
      </div>
    </div>
    <m-modal :option="delLimitAmountOption" @trigger="trigger"></m-modal>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import disItem from './Temp/DisItemTableTemp.vue'
export default {
  name: 'LimitedScheduleItemTable',
  data () {
    return {
      roleType: 0,
      brandBrief: [],
      storeBrief: [],
      brandSelect: {
        value: 999999,
        label: ''
      },
      storeSelect: {
        value: 999999,
        label: '==門市=='
      },
      settingList: [],
      total: 1,
      count: 20,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      current: {
        store_list: [],
        name: ''
      },
      checkBoxSelectAll: false,
      del_fun: false,
      delLimitAmountOption: {
        id: 'limiModal',
        title: '刪除勾選的限時限量設定',
        body: '',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'delSelectedLimit'
          }
        ]
      },
      enable_add: false,
      selectAllItem: false,
      isLoading: true
    }
  },
  mounted () {
  },
  components: {
    'dis-item-table': disItem
  },
  methods: {
    trigger (event) {
      if (event === 'delSelectedLimit') {
        this.deleteLimitAmount()
      }
    },
    deleteLimitAmount () {
      const deleteItem = this.settingList.filter(x => x.selectItem).map(x => x.setting_id)
      if (deleteItem.length > 0) {
        var url = 'storeOrderAmountLimitSetting/batchDelete?setting_ids=' + deleteItem.toString()
        this.getDataH('delete', url, null, (response) => {
          if (response.data.status === 200) {
            this.del_fun = false
            this.getAmountLimitSetting()
          }
        })
      }
    },
    del_item () {
      this.del_fun = true
    },
    enable_limit () {
      if (this.storeSelect.value === 999999 || !this.storeSelect) {
        this.$notify({
          title: '請選擇門市',
          text: '請選擇門市',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if (this.enable_add) {
        this.$router.push('/crLimitScheduleItem?store_id=' + this.storeSelect.value + '&brand_id=' + this.brandSelect.value)
      } else {
        this.$notify({
          title: '設定已啟用',
          text: '設定已啟用',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      }
    },
    selectAll () {
      this.settingList = this.settingList.map(x => {
        return {
          ...x,
          selectItem: this.selectAllItem
        }
      })
    },
    getStoreInfo (storeID) {
      const self = this
      const url = '/store/' + storeID + '/info'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.brandSelect.value = Number(response.data.info.brand_id)
          if (response.data.info.is_visible === 1) {
            self.brandSelect.label = response.data.info.brand_name + ' (測)'
          } else {
            self.brandSelect.label = response.data.info.brand_name
          }
          // self.storeSelect.label = response.data.info.name
          // self.getStoreBrief(self.brandSelect.value)
        }
      })
    },
    getBrandBrief () {
      var self = this
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC'
      const roleType = parseInt(this.getRoleType, 10)
      const brand = Number(self.$route.query.brand)
      const store = Number(self.$route.query.store)
      return new Promise((resolve, reject) => {
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            var bList = response.data.list
            for (let i = 0; i < bList.length; i++) {
              let obj = {label: bList[i].name, value: bList[i].brand_id}
              if (!bList[i].is_visible) obj.label = obj.label + ' (測)'
              self.brandBrief.push(obj)
              // 避免重複行為產生
              if (i === 0 && !brand && !store) {
                self.brandSelect = obj
              }
              if (roleType !== 99 && roleType !== 30) {
                self.getStoreBrief(self.brandSelect.value)
              } else if (self.$route.query.brand) {
                if (brand === obj.value) {
                  self.brandSelect.label = obj.label
                  self.getAmountLimitSetting()
                }
              }
            }
            return resolve()
          }
        })
      })
    },
    getStoreBrief (brandId) {
      console.log('getStoreBrief | LimitedScheduleItemTable')
      if (this.roleType !== 10) this.storeBrief = [{label: '==門市==', value: 999999}]
      else this.storeBrief = []
      var self = this
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list
          if (self.roleType !== 10) {
            self.storeSelect = {
              value: 999999,
              label: '== 門市 =='
            }
          }
          for (let i = 0; i < sList.length; i++) {
            let obj = {label: sList[i].name, value: sList[i].store_id}
            self.storeBrief.push(obj)
            // else if (i === 0) self.storeSelect.value = 999999
            if (i === 0 && self.getRoleType === 10) {
              self.storeSelect = obj
              self.getAmountLimitSetting()
            } else if (self.$route.query.store) {
              const store = Number(self.$route.query.store)
              if (store === obj.value) {
                self.storeSelect = obj
                self.getAmountLimitSetting()
              }
            }
            // }
          }
          if (!sList.length) {
            self.settingList = []
            self.total = 0
          }
          // self.getOnlineMenu()
        }
      })
    },
    getAmountLimitSetting (type) {
      this.isLoading = true
      var self = this
      // var url = '/brand/' + this.brandSelect.value + '/productDisableScheduleSetting/list?page=' + this.tableIndex + '&size=' + this.count
      let url = '/storeOrderAmountLimitSetting/list?size=' + this.count
      let queryValue = {}
      return new Promise((resolve, reject) => {
        if (type !== 'useBrand' && this.storeSelect.value !== 999999 && (self.getRoleType === 99 || self.getRoleType === 30)) {
          if (this.$route.query.store !== this.storeSelect.value) {
            queryValue = {...queryValue, ...{store: this.storeSelect.value}}
            this.tableIndex = 1
          } else queryValue = {...queryValue, ...{store: this.storeSelect.value}}
          url = url + '&brand_id=' + this.brandSelect.value + '&store_id=' + this.storeSelect.value
          // url = '/store/' + this.storeSelect.value + url
        } else if (this.brandSelect.value !== 999999 && (self.getRoleType === 99 || self.getRoleType === 30)) {
          if (this.$route.query.brand !== this.brandSelect.value) {
            this.tableIndex = 1
            queryValue = {...queryValue, ...{brand: this.brandSelect.value, page: 1}}
          } else queryValue = {...queryValue, ...{brand: this.brandSelect.value}}
          url = url + '&brand_id=' + this.brandSelect.value
        }
        if (self.tableIndex) {
          queryValue = {...queryValue, ...{page: this.tableIndex}}
          url = url + '&page=' + this.tableIndex
        }
        // if (this.storeSelect.value !== 999999) url = '/store/' + this.storeSelect.value + '/productDisableScheduleSetting/list?page=' + this.tableIndex + '&size=' + this.count
        if (!this.$route.query.brand && !this.$route.query.store && this.getRoleType !== 10) {
          // url = '/brand/' + this.brandSelect.value + '/productDisableScheduleSetting/gruop/list?&page=' + this.tableIndex + '&size=' + this.count
        }
        if (self.getRoleType === 10 && self.storeSelect.value !== 999999) {
          url = url + '&brand_id=' + this.brandSelect.value + '&store_id=' + this.storeSelect.value
        }
        this.$router.push({query: queryValue})
        this.getDataH('get', url, null, function (response) {
          if (response.data.status === 200) {
            self.enable_add = false
            self.settingList = response.data.list
            self.isLoading = false
            if (self.settingList.length === 0 && self.storeSelect.value && self.storeSelect.value !== 999999) {
              self.enable_add = true
            }
            self.total = response.data.meta.total
            return resolve()
          }
        })
      })
    },
    clickCurrent (menu) {
      this.current = menu
    },
    clickGroup (type) {
      if (type === 'left' && this.pageGroup !== 1) {
        this.pageGroup = this.pageGroup - 1
        this.tableIndex = this.groupAmount * this.pageGroup
        this.clickPage(this.tableIndex)
      } else if (type === 'right' && this.pageGroup !== Math.ceil(this.pageAmount / this.groupAmount)) {
        this.pageGroup = this.pageGroup + 1
        this.tableIndex = this.groupAmount * (this.pageGroup - 1) + 1
        this.clickPage(this.tableIndex)
      }
    },
    clickEnd (type) {
      if (type === 'pre') {
        this.clickPage(1)
        this.pageGroup = 1
      } else if (type === 'forward') {
        if (this.pageAmount) this.clickPage(this.pageAmount)
        else this.clickPage(1)
        this.pageGroup = Math.ceil(this.pageAmount / this.groupAmount)
      }
    },
    clickPage (index) {
      this.tableIndex = index
      if (index === 1) this.pageGroup = 1
      this.getAmountLimitSetting()
    },
    isActive (index) {
      if (Number(this.tableIndex) === index) return true
      else return false
    }
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    fixedH () {
      return this.$parent.fixedH
    },
    pageAmount () {
      return Math.ceil(this.total / this.count)
    }
  },
  async created () {
    // 平台99 品牌30 門市10
    this.roleType = parseInt(this.getRoleType, 10)
    this.fixedH()
    if (this.$route.query.brand) this.brandSelect.value = await this.$route.query.brand
    if (this.$route.query.page) this.tableIndex = await this.$route.query.page
    await this.getBrandBrief()
    if (this.$route.query.store && this.roleType !== 10) {
      if (this.roleType === 30) {
        this.storeSelect.value = this.$route.query.store
      }
      await this.getStoreInfo(this.$route.query.store)
    }
    if ((!this.$route.query.brand && !this.$route.query.store) && this.roleType !== 10) {
      await this.getAmountLimitSetting()
    }
  },
  watch: {
    'brandSelect.value' () {
      // this.storeSelect = {
      //   value: 999999,
      //   label: '==門市=='
      // }
      if (this.brandSelect.value !== 999999 && this.brandSelect && (this.roleType === 99 || this.roleType === 30)) {
        this.getStoreBrief(this.brandSelect.value)
      }
    },
    'storeSelect.value' () {
      if (this.storeSelect.value === 999999) {
        this.enable_add = false
      }
    }
  }
}
</script>

<style scpoed>
/* Using the bootstrap style, but overriding the font to not draw in
   the Glyphicons Halflings font as an additional requirement for sorting icons.

   An alternative to the solution active below is to use the jquery style
   which uses images, but the color on the images does not match adminlte.

@import url('/static/js/plugins/datatables/jquery.dataTables.min.css');
*/

@import url('/static/js/plugins/datatables/dataTables.bootstrap.css');
table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after {
  font-family: 'FontAwesome';
}

table.dataTable thead .sorting:after {
  content: "\f0dc";
}

table.dataTable thead .sorting_asc:after {
  content: "\f0dd";
}

table.dataTable thead .sorting_desc:after {
  content: "\f0de";
}
@media screen and (min-width: 768px) {
  .search-bar {
    max-width: calc( 100% - 98px)
  }
  .form-inline .form-group {
    margin-bottom: 15px !important;
  }
}
.search-bar .input-group input{
  border-radius: 3px 0px 0px 3px !important;
}
.search-bar .input-group span{
  border-radius: 0px 3px 3px 0px !important;
}
.btn-table-enable {
  padding: 16px 36px;
}
</style>



// WEBPACK FOOTER //
// LimitedScheduleItemTable.vue?6407de37